export const images = [
  {
    url: "./images/home/banner--004.jpg",
    title: "CONVIÉRTETE EN EXPERTO FLEISCHMANN",
    subtitle: "Espéralo muy pronto",
  },
];

export const navidadImgs = [
  {
    url: "./images/home/BannersPaginaNav.jpg",
    title: null,
    subtitle: null,
    activeButton: false,
  },
];

export const lanzamientoimgs = {
  mobile: "/images/lanzamientos/Banner-390x500px.png",
  tablet: "/images/lanzamientos/Banner-1024x400px.png",
  standard: "/images/lanzamientos/Banner-1366x430px.png",
  hd: "/images/lanzamientos/Banner-1920x600px.png",
};

export const imgs = [
  {
    url: "./images/home/banner--001.jpg",
    title: "DEMOSTRACIONES",
    subtitle: "de producto",
  },
  {
    url: "./images/home/banner--002.jpg",
    title: "CAPACITACIONES",
    subtitle: "por expertos",
    style: {
      objectPosition: "center top",
    },
  },
  {
    url: "./images/home/banner--003.jpg",
    title: "FORMACIÓN",
    subtitle: "en Panadería y Pastelería",
  },
];
